import { Typography, Grid } from "@mui/material";
import React from "react";
import { CustomerInterface } from "../../Objects/Customer";

export interface CustomerMail2Props {
    customerData: CustomerInterface
}

const CustomerMail2: React.FC<CustomerMail2Props> = ({
    customerData
}) => {
    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant="caption" sx={{color: "#333399"}}>E-Mail（PC）</Typography>
            </Grid>
            <Grid item>
                <Typography variant="body1">{customerData.ctm_mail2 ? customerData.ctm_mail2 : "未登録"}</Typography>
            </Grid>
        </Grid>
    );
}

export default CustomerMail2